import { useState } from 'react';

export const tabs = [
  { label: '总览', value: 'overview' },
  { label: '持仓分析', value: 'holdings' },
  { label: '交易行为', value: 'trading' },
  { label: '优化推荐', value: 'recommendations' },
  { label: '服务推荐', value: 'servicesRecommendations' }
];

export type TabValue = (typeof tabs)[number]['value'];

export const useTabControl = () => {
  const [activeTab, setActiveTab] = useState<TabValue>('overview');

  const handleTabChange = (value: string | number) => {
    setActiveTab(value as TabValue);
  };

  return {
    tabs,
    activeTab,
    setActiveTab: handleTabChange
  };
};
